import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { MainGuideSection } from '../components/MainGuideSection';
import { InsidePreviewSection } from '../components/InsidePreviewSection';
import { BonusSection } from '../components/BonusSection';
import { AudienceSection } from '../components/AudienceSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { SiteFooter } from '../components/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-167" data-mp="3qq1f6ko5xz8p">
      <SiteHeader data-id="element-168" data-mp="3vmrxlenfx6xa" />
      <main data-id="element-169" data-mp="3vo2y95ll9yk6">
        <HeroSection data-id="element-170" data-mp="3vnth87iiv1qm" />
        <ProblemSection data-id="element-171" data-mp="3vpe4dc2ibieg" />
        <MethodSection data-id="element-172" data-mp="3ajgip20b3u02" />
        <MainGuideSection data-id="element-173" data-mp="3akrvfrbqcc3b" />
        <InsidePreviewSection data-id="element-174" data-mp="3al1bon6z34vt" />
        <BonusSection data-id="element-175" data-mp="35t04vgskq6d6" />
        <AudienceSection data-id="element-176" data-mp="35si1m07hurvr" />
        <OfferSection data-id="element-177" data-mp="35s88i3r5k4lu" />
        <GuaranteeSection data-id="element-178" data-mp="35qx2dxa8ikrk" />
        <FaqSection data-id="element-179" data-mp="30tni0w1pczal" />
        <FinalCtaSection data-id="element-180" data-mp="30t5dzd8stgs4" />
      </main>
      <SiteFooter data-id="element-181" data-mp="30u6mpb2cdr6o" />
    </div>;
}